import React, { useEffect, useRef } from 'react';
import { sponsorsAPI } from '../utils/api';

/**
 * 피드 스폰서 카드 — 광고-콘텐츠 분리 원칙의 렌더 단.
 * - "광고" 라벨 + disclosure_text를 항상 노출한다 (라벨 의무).
 * - 마운트 시 노출 1회, CTA 클릭 시 클릭 로그를 남긴다 (리포팅 근거).
 * - 잉크 디자인: 일반 글 카드와 같은 문법이되 점선 보더로 구분.
 */
const pick = (o: any, ...keys: string[]): any => {
  for (const k of keys) if (o?.[k] !== undefined && o?.[k] !== null) return o[k];
  return undefined;
};

export default function SponsoredCard({ ad, specialty }: { ad: any; specialty?: string }) {
  const logged = useRef(false);

  useEffect(() => {
    if (logged.current) return;
    logged.current = true;
    sponsorsAPI.logImpression(ad.id, specialty).catch(() => {});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ad.id]);

  const title = pick(ad, 'title');
  const body = pick(ad, 'body');
  const imageUrl = pick(ad, 'image_url', 'imageUrl');
  const ctaText = pick(ad, 'cta_text', 'ctaText');
  const ctaUrl = pick(ad, 'cta_url', 'ctaUrl');
  const disclosure = pick(ad, 'disclosure_text', 'disclosureText') || '광고 · 유료 협찬';
  const sponsorName = pick(ad, 'sponsor_name', 'sponsorName');

  const onCta = () => {
    sponsorsAPI.logClick(ad.id, specialty).catch(() => {});
    if (ctaUrl) window.open(ctaUrl, '_blank', 'noopener,noreferrer');
  };

  return (
    <div className="bg-white rounded-xl border border-dashed border-gray-300 p-4 lg:p-6">
      <div className="flex items-center gap-2 mb-3">
        <span className="px-2 py-0.5 rounded-full text-xs font-medium text-gray-500 border border-gray-300 bg-white">광고</span>
        <span className="text-xs text-gray-400">{disclosure}{sponsorName ? ` · ${sponsorName}` : ''}</span>
      </div>
      <h3 className="font-semibold text-gray-900 mb-1">{title}</h3>
      {body && <p className="text-sm text-gray-600 whitespace-pre-line mb-3">{body}</p>}
      {imageUrl && <img src={imageUrl} alt="" className="w-full max-h-56 object-contain rounded-lg border border-gray-100 mb-3" />}
      {ctaUrl && (
        <button
          onClick={onCta}
          className="px-4 py-2 bg-gray-900 text-white rounded-lg hover:bg-gray-700 text-sm"
        >
          {ctaText || '자세히 보기'}
        </button>
      )}
    </div>
  );
}
